<div class="modal-header">
    <h4 class="modal-title">Leprosy</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body" [formGroup]="leprosyForm">
        <div class="row">
            <div class="col-xl-12">
                <div class="form-row">
                    <label>Skin Patch Present</label>
                    <div class="options">
                        <input type="radio" formControlName="skin_patch_present" [value]="true">Yes
                        &nbsp;
                        <input type="radio" formControlName="skin_patch_present" [value]="false">No
                    </div>
                </div>
                <div class="form-row">
                    <label>Loss Of Sensation</label>
                    <div class="options">
                        <input type="radio" formControlName="loss_of_sensation" [value]="true">Yes &nbsp;
                        <input type="radio" formControlName="loss_of_sensation" [value]="false">No
                    </div>
                </div>
                <div class="form-row">
                    <label>Numbness in hands/feet</label>
                    <div class="options">
                        <input type="radio" formControlName="numbness_in_hands_feet" [value]="true">Yes
                        &nbsp;
                        <input type="radio" formControlName="numbness_in_hands_feet" [value]="false">No
                    </div>
                </div>
                <div class="form-row">
                    <label>Visible deformity</label>
                    <div class="options">
                        <input type="radio" formControlName="visible_deformity" [value]="true">Yes &nbsp;
                        <input type="radio" formControlName="visible_deformity" [value]="false">No
                    </div>
                </div>
                <div class="form-row">
                    <label>Screening Result </label>
                    <div class="options">
                        <input type="radio" formControlName="screening_result" [value]="'Normal'">Normal
                        &nbsp;
                        <input type="radio" formControlName="screening_result" [value]="'Suspected'">Suspected &nbsp;
                        <input type="radio" formControlName="screening_result" [value]="'Confirmed'">Confirmed
                    </div>
                </div>
                <div class="form-row">
                    <label>Referred</label>
                    <div class="options">
                        <input type="radio" formControlName="referred" [value]="true">Yes &nbsp;
                        <input type="radio" formControlName="referred" [value]="false">No
                    </div>
                </div>
                <div class="form-row" *ngIf="leprosyForm.get('referred')?.value === true">
                    <label>Referred Facility</label>
                    <div class="options">
                        <input type="text" class="form-control form-control-sm" formControlName="referral_facility">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('Close click')">Close</button>
</div>